import { compact, flow, join, map } from 'lodash/fp';

const getFallbackTitle = (ad) => {
  const order = ['manufacturer', 'model', 'subType', 'subTypeExtra'];
  const vehicle = ad.vehicle || ad;

  return flow(
    map((key) => vehicle[key]),
    compact,
    join(' '),
  )(order);
};

export const getAdTitle = (ad) => {
  const { title } = ad;

  if (title) {
    return title;
  }

  return getFallbackTitle(ad);
};
